var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArroNextBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9993 9.16699H2.49935C1.99935 9.16699 1.66602 9.50033 1.66602 10.0003C1.66602 10.5003 1.99935 10.8337 2.49935 10.8337H11.9993V9.16699Z",
    fill: "#7E8299"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M12 16.6663V3.33301L18.0833 9.41633C18.4167 9.74966 18.4167 10.2497 18.0833 10.583L12 16.6663Z",
    fill: "#7E8299"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArroNextBlack);
export default __webpack_public_path__ + "static/media/arro-next-black.9fb59d30ba67ca840c32b37010188ae8.svg";
export { ForwardRef as ReactComponent };